var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoPlayer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.817,
    height: 53.401,
    viewBox: "0 0 65.817 53.401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    transform: "translate(-14.6 -19.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16433",
    "data-name": "Path 16433",
    d: "M62.721,22.368c.267.134.668.4.935.534s.668.4.935.534c-.133.4-.133.8-.267,1.2s-.134.8-.267,1.335c.4.267.668.668,1.068.935.534-.134.935-.267,1.335-.4l1.2-.4c.134.267.4.668.534.935s.4.668.534.935a5.806,5.806,0,0,0-.8.935,5.806,5.806,0,0,0-.8.935,6.019,6.019,0,0,1,.4,1.469c.4.134.935.134,1.2.267.534.133.8.133,1.2.267v2.4l-1.2.4a9.2,9.2,0,0,1-1.068.4l-.4,1.6.8.8a5.807,5.807,0,0,1,.935.8c-.133.267-.4.668-.534.935s-.4.668-.534.935c-.4-.133-.8-.133-1.2-.267a2.475,2.475,0,0,1-.935-.267,12.036,12.036,0,0,1-1.2,1.335,3.4,3.4,0,0,1,.267.935l.4,1.2c-.267.134-.668.4-.935.534s-.668.4-.935.534a5.807,5.807,0,0,0-.935-.8,2.912,2.912,0,0,0-.668-.534,7.653,7.653,0,0,1-1.869.534c0,.267-.133.534-.133.8a4.052,4.052,0,0,0-.4,1.469h-2.4l-.4-1.2c-.133-.267-.133-.534-.267-.8a11.121,11.121,0,0,1-2-.534,2.344,2.344,0,0,0-.534.668,5.807,5.807,0,0,1-.8.935c-.267-.133-.668-.4-.935-.534s-.668-.4-.935-.534c.134-.4.134-.8.267-1.2,0-.267.134-.534.134-.8a12.586,12.586,0,0,1-1.335-1.335c-.267.134-.534.134-.8.267l-1.2.4c-.134-.267-.4-.668-.534-.935s-.4-.668-.534-.935a5.806,5.806,0,0,0,.8-.935l.668-.668a7.653,7.653,0,0,1-.534-1.869,2.606,2.606,0,0,0-.935-.134c-.534-.134-.8-.134-1.2-.267v-2.4l1.2-.4c.267-.134.668-.134.935-.267a8.635,8.635,0,0,1,.534-1.736l-.8-.8a5.807,5.807,0,0,1-.935-.8c.133-.267.4-.668.534-.935s.4-.668.534-.935c.4.134.8.134,1.2.267s.8.134,1.2.267a8.056,8.056,0,0,1,1.068-1.068l-.4-1.2-.4-1.2c.267-.134.668-.4.935-.534s.668-.4.935-.534a5.806,5.806,0,0,0,.935.8l.935.935c.4-.134.935-.267,1.469-.4.134-.534.134-.935.267-1.335.134-.534.134-.8.267-1.2h2.4l.4,1.2c.134.4.267.8.4,1.335.534.134.935.267,1.335.4.4-.4.668-.8.935-1.068a4.848,4.848,0,0,0,.935-1.2Z",
    transform: "translate(10.487 0.603)",
    fill: "#e00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16434",
    "data-name": "Path 16434",
    d: "M56.575,25.6A6.675,6.675,0,1,1,49.9,32.275,6.782,6.782,0,0,1,56.575,25.6Z",
    transform: "translate(11.827 1.91)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16435",
    "data-name": "Path 16435",
    d: "M35.243,19.9h-.133a6.5,6.5,0,0,0-1.6.134,12.5,12.5,0,0,0-2.136.534,5.281,5.281,0,0,0-2,1.335,4.2,4.2,0,0,0-1.068,2,11.12,11.12,0,0,0-.4,2.937,10.1,10.1,0,0,0,.134,2c.134.668.267,1.2.4,1.869a4.467,4.467,0,0,0,1.6,2.27,5.08,5.08,0,0,0,2.27,1.068,10.411,10.411,0,0,0,2.937.4,7.612,7.612,0,0,0,1.736-.134,11.122,11.122,0,0,0,2-.534,5.436,5.436,0,0,0,2.27-1.6,5.08,5.08,0,0,0,1.068-2.27,16.017,16.017,0,0,0,.4-2.67,8.21,8.21,0,0,0-.134-1.869c-.133-.668-.267-1.335-.4-1.869a6.179,6.179,0,0,0-1.736-2.4,5.08,5.08,0,0,0-2.27-1.068C37.245,20.034,36.177,19.9,35.243,19.9Z",
    transform: "translate(4.456 0)",
    fill: "#e00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7840",
    "data-name": "Group 7840",
    transform: "translate(39.165 49.404)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4514",
    "data-name": "Rectangle 4514",
    width: 1.202,
    height: 9.078,
    fill: "#303337"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7843",
    "data-name": "Group 7843",
    transform: "translate(24.533 47.711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7841",
    "data-name": "Group 7841",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4515",
    "data-name": "Rectangle 4515",
    width: 8.945,
    height: 1.202,
    transform: "translate(0 6.789) rotate(-49.376)",
    fill: "#303337"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7842",
    "data-name": "Group 7842",
    transform: "translate(23.563 0.34)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4516",
    "data-name": "Rectangle 4516",
    width: 1.202,
    height: 8.411,
    transform: "translate(0 0.86) rotate(-45.681)",
    fill: "#303337"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_16436",
    "data-name": "Path 16436",
    d: "M50.7,43.648C49.367,36.973,43.626,31.9,36.951,31.9S24.535,36.973,23.2,43.648Z",
    transform: "translate(2.881 4.02)",
    fill: "#e00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7844",
    "data-name": "Group 7844",
    transform: "translate(50.646 54.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16437",
    "data-name": "Path 16437",
    d: "M47.471,46.034h-.8A3.142,3.142,0,0,0,45.6,46.3a2.4,2.4,0,0,0-.935.668,3.346,3.346,0,0,0-.534.935A5.476,5.476,0,0,0,44,49.371v.935a2.475,2.475,0,0,0,.267.935,2.076,2.076,0,0,0,.8,1.068,2.684,2.684,0,0,0,1.068.534,5.006,5.006,0,0,0,1.469.133h.8a2.475,2.475,0,0,0,.935-.267,2.076,2.076,0,0,0,1.068-.8,2.683,2.683,0,0,0,.534-1.068,4.116,4.116,0,0,0,.134-1.335V48.57a2.475,2.475,0,0,0-.267-.935,3.153,3.153,0,0,0-.8-1.2A2.684,2.684,0,0,0,48.94,45.9,5.476,5.476,0,0,1,47.471,46.034Z",
    transform: "translate(-40.796 -45.9)",
    fill: "#e00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16438",
    "data-name": "Path 16438",
    d: "M54.95,57.407a6.777,6.777,0,0,0-13.35,0Z",
    transform: "translate(-41.6 -43.923)",
    fill: "#e00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7845",
    "data-name": "Group 7845",
    transform: "translate(33.023 59.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16439",
    "data-name": "Path 16439",
    d: "M34.3,49.8h-.8a3.142,3.142,0,0,0-1.068.267,2.4,2.4,0,0,0-.935.668,3.346,3.346,0,0,0-.534.935,4.8,4.8,0,0,0-.267,1.469v.935a2.475,2.475,0,0,0,.267.935,2.076,2.076,0,0,0,.8,1.068,2.683,2.683,0,0,0,1.068.534,5.006,5.006,0,0,0,1.469.133h.8a2.475,2.475,0,0,0,.935-.267,2.076,2.076,0,0,0,1.068-.8,2.684,2.684,0,0,0,.534-1.068,4.116,4.116,0,0,0,.134-1.335v-.935a2.475,2.475,0,0,0-.267-.935,3.152,3.152,0,0,0-.8-1.2c-.267.134-.534-.133-.935-.133A5.678,5.678,0,0,0,34.3,49.8Z",
    transform: "translate(-27.629 -49.8)",
    fill: "#e00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16440",
    "data-name": "Path 16440",
    d: "M41.75,61.307a6.777,6.777,0,0,0-13.35,0Z",
    transform: "translate(-28.4 -47.823)",
    fill: "#e00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7846",
    "data-name": "Group 7846",
    transform: "translate(14.6 54.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16441",
    "data-name": "Path 16441",
    d: "M20.5,45.734h-.8A3.142,3.142,0,0,0,18.636,46a2.4,2.4,0,0,0-.935.668,3.346,3.346,0,0,0-.534.935,4.8,4.8,0,0,0-.267,1.469v.935a2.475,2.475,0,0,0,.267.935,2.076,2.076,0,0,0,.8,1.068,2.683,2.683,0,0,0,1.068.534,5.006,5.006,0,0,0,1.469.134h.8a2.475,2.475,0,0,0,.935-.267,2.076,2.076,0,0,0,1.068-.8,2.683,2.683,0,0,0,.534-1.068,4.116,4.116,0,0,0,.134-1.335V48.27a2.475,2.475,0,0,0-.267-.935,3.152,3.152,0,0,0-.8-1.2A2.684,2.684,0,0,0,21.84,45.6,4.541,4.541,0,0,1,20.5,45.734Z",
    transform: "translate(-13.829 -45.6)",
    fill: "#e00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16442",
    "data-name": "Path 16442",
    d: "M27.95,57.107a6.777,6.777,0,0,0-13.35,0Z",
    transform: "translate(-14.6 -43.623)",
    fill: "#e00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPlayer);
export default __webpack_public_path__ + "static/media/no_player.efdbd0b8fa37dc6ebd15ba408bdbd4a5.svg";
export { ForwardRef as ReactComponent };